import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBus, FaBusinessTime, FaNoteSticky, FaStore } from 'react-icons/fa6';
import { BsArrowUpRight } from 'react-icons/bs';

import { toast } from 'react-toastify'; // Import Toastify
import 'react-toastify/dist/ReactToastify.css'; // Import Toastify CSS
import emailjs from '@emailjs/browser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faLock, faPlane, faTruck } from '@fortawesome/free-solid-svg-icons';

function Home() {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 1;
    }
  
    return () => {
      videoRef.current = null; // Cleanup
    };
  }, []);
  

 const fleetItems = [
    {
      vehicle: "Home Moving",
      description: "Operating a full fleet of modern removal vehicles for any size service. ",
      icon: <FontAwesomeIcon icon={faTruck} className="w-20  h-20 text-black" />,
    },
    {
      vehicle: "Air Freight",
      description: "Worldwide air freight services for your moving or commercial shipments.",
      icon:<FontAwesomeIcon icon={faPlane} className="w-20  h-20 text-black" />,
    },
    {
      vehicle: "International Shipping",
      description: "Overseas shipping to over 180 coutries for a full door to door relocation.",
      icon: <FontAwesomeIcon icon={faGlobe} className="w-20  h-20 text-black" />,
    },
    {
      vehicle: "Storage",
      description: "Security is our name. Providing safe and secure storage for all your posessions.",
      icon:<FontAwesomeIcon icon={faLock} className="w-20  h-20 text-black" />,
    },
    {
      vehicle: "Business Moving",
      description: "Providing exceptional business and corporate moving services.",
      icon: <FaBusinessTime className="w-20  h-20 text-black" />,
    },
    {
      vehicle: "Insurance",
      description: "Fully insured Company providing correct cover for every move.",
      icon: <FaNoteSticky className="w-20  h-20 text-black" />,
    },
   
  ];

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    description: '',
  });

  const [errors, setErrors] = useState({});
  const formRef = useRef();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });

    // Clear the error for the current field
    setErrors((prevErrors) => ({ ...prevErrors, [id]: '' }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate fields
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    if (!formData.phone.trim()) newErrors.phone = 'Phone is required';
    if (!formData.description.trim()) newErrors.description = 'Message is required';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error('Please fill out all required fields!');
      return;
    }

    // Send email using emailjs
    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: formData.name,
          from_email: formData.email,
          from_phone: formData.phone,
          from_message: formData.description,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (result) => {
          console.log('Success:', result.text);
          toast.success('Message sent successfully!');
          setFormData({ name: '', email: '', phone: '', description: '' });
        },
        (error) => {
          console.error('Error:', error.text);
          toast.error('Error sending message!');
        }
      );
  };
  const services = [
    "Business Same Day Delivery",
    "Domestic Same Day Delivery",
    "Two-Man Delivery",
    "Overnight Delivery",
    "Exhibition & Event Deliveries",
    "Medical Deliveries",
    // "Industrial Estate Deliveries"
  ];

 

  return (
    <div>
    <div className="relative ">

    <div className="h-screen w-full overflow-hidden">
    {/* <div className="absolute w-full lg:w-1/2 inset-0 bg-black h-screen bg-opacity-50"></div> */}

  <video
    ref={videoRef}
    autoPlay
    loop
    muted
    playsInline
    className="w-full h-full object-cover"
  >
    <source src="images/Landingvideo.mp4" type="video/mp4" />
    Your browser does not support the video.
  </video>
</div>

{/* glass frame  */}
      <div className="absolute top-28 md:top-52 xl:top-40  max-w-2xl lg:max-w-xl xl:max-w-2xl 2xl:max-w-4xl m-2 ">
  <p className="text-white  text-4xl md:text-6xl 2xl:text-7xl text-center p-2 lg:text-left xl:pl-20 font-bold">
  Seamless logistics driving with precision and reliability.
  </p>
  <div className="flex flex-col  text-center md:text-md  text-white justify-center lg:mr-20   p-4 2xl:p-2  mt-4 xl:mt-1">
  <p>
  Reliable Logistics Services tailored for your needs. From Domestic to International relocations, we ensure a seamless experience for residential, business, and corporate clients.
  </p>
  <div className="flex justify-center items-center mt-6">
  <Link to="/contactus">
    <button className="bg-slate-800 w-48 xl:w-56 text-xl xl:text-xl h-12 xl:h-12 flex items-center justify-center  text-center text-white px-6 py-2  mt-2">
      Get Quote  
      <BsArrowUpRight size={18} className="ml-2" /> 
    </button>
  </Link>
</div>
  </div>
</div>


{/* <TransportCards/> */}
      <div className="flex flex-col md:flex-row items-center p-4 md:p-4 justify-center space-y-6 md:space-y-0 md:gap-20 xl:gap-40 mt-12 md:mt-20">
        <div className="md:w-1/2 2xl:w-1/3 flex justify-center">
          <img 
            src="images/homecase1.jpg" 
            alt="Freight Platform" 
            className="w-full h-[500px] max-w-2xl md:h-[550px] rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
          />
        </div>
        <div className="md:w-1/2 2xl:w-1/3 text-center md:text-left space-y-8 md:text-lg ">
        <p className=' text-5xl xl:text-8xl font-thin'>Who are we</p>
       
 <p className=" text-base  lg:text-xl xl:text-2xl  text-justify max-w-xl leading-relaxed text-gray-600 font-thin">
 We are a logistics company who manage an extensive network of over 2,500 drivers strategically positioned across the UK. Renowned for our dependable same-day delivery service, we ensure prompt and professional collection and delivery every time. With a dedicated team operating round the clock, we guarantee a swift 60-minute collection window, no matter the pickup location. Our unwavering commitment to excellence has earned us a distinguished reputation for outstanding service
 </p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-center p-4 md:p-8 justify-center space-y-6 md:space-y-0 md:gap-20 xl:gap-40 md:mt-20">
      {/* <div className="md:w-1/2 2xl:w-1/3  md:hidden flex justify-center">
          <img 
            src="images/case22.png" 
            alt="Freight Platform" 
            className="w-full h-[500px] max-w-xl md:h-[600px]  md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
          />
        </div> */}
        <div className="  md:w-1/2 2xl:w-1/3 text-center md:text-left space-y-4 md:text-lg">
        <p className='text-5xl xl:text-8xl font-thin text-center'>We are good at moving with care</p>

 <p className="text-base lg:text-xl xl:text-2xl font-thin text-justify max-w-xl leading-relaxed text-gray-600">
 Every move, whether for your home or business, local or international, requires meticulous care and attention.
  At 1UK Logistics, we employ only full-time, professionally trained crews. With ongoing training and the use of
   top-tier packing materials and equipment, our teams ensure your belongings, whether personal or corporate,
    are handled safely and efficiently from start to finish. We believe that exceptional service should be the standard, providing a seamless and high-quality experience for all relocations
 </p>
        </div>
        <div className="  md:w-1/2 2xl:w-1/3 md:flex justify-center">
          <img 
            src="images/case22.png" 
            alt="Freight Platform" 
            className="w-full h-auto max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
          />
        </div>
      </div>


      <div className="flex bg-black flex-col md:flex-row items-center p-4 md:p-8 justify-center space-y-6 md:space-y-0 md:gap-20 xl:gap-40  mt-20">
        <div className="md:w-1/2 2xl:w-1/3 flex justify-center">
          <img 
            src="images/ukb.png" 
            alt="Freight Platform" 
            className="w-full h-[500px] max-w-md md:h-[600px] rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
          />
        </div>
        <div className="md:w-1/2 2xl:w-1/3 text-center md:text-left space-y-4 md:text-lg">
        <p className='text-5xl xl:text-8xl font-thin text-center text-white'>Nation wide Services</p>

 <p className="text-base lg:text-xl xl:text-2xl font-thin text-justify max-w-xl leading-relaxed text-gray-500">
 We are at your service around the clock, every day of the year. Our express delivery options cater to projects of all sizes. From crucial paperwork to bulky items, we’ll collaborate with you to identify the ideal approach for your needs
 </p>
        </div>
      </div>

      {/* <div>
<section id="fleet" className="py-16 bg-white-800 text-black flex gap-12 justify-center items-center ">
  <div>
    <p className='text-[190px]  leading-[180px] font-bold text-center'>Services<br/> we<br/> offer</p>
  </div>

        <div className="grid grid-cols-2 sm:grid-cols-2  lg:grid-cols-3 gap-6  justify-items-center">
          {fleetItems.map((item, index) => (
            <div key={index} className="flex flex-col gap-6 bg-slate-200 p-6 w-[300px] rounded-xl items-center text-center mt-6">
              <div className="mb-2  text-red-500">{item.icon}</div>
              <h3 className="text-xl font-semibold mb-1  ">{item.vehicle}</h3>
              <p className="text-zinc-500  max-w-sm">{item.description}</p>
            </div>
          ))}
        </div>
      </section>
  </div> */}

<div className="bg-white text-black px-4 py-16">
  <section id="fleet" className="flex flex-col lg:flex-row items-center justify-center gap-32 max-w-7xl mx-auto">
    
    {/* Left Section - Title */}
    <div className="text-center lg:text-center w-full lg:w-1/3">
      <p className="text-[50px] sm:text-[80px] md:text-[120px] lg:text-[90px] xl:text-[120px] 2xl:text-[120px] font-thin leading-tight">
        Services<br />we<br /> offer
      </p>
    </div>

    {/* Fleet Grid */}
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 w-full lg:w-2/3">
      {fleetItems.map((item, index) => (
        <div key={index} className="flex flex-col items-center text-center bg-slate-200 p-6 rounded-xl shadow-lg w-full max-w-[300px] mx-auto">
          <div className="mb-2 text-red-500 text-4xl">{item.icon}</div>
          <h3 className="text-lg md:text-xl font-semibold">{item.vehicle}</h3>
          <p className="text-zinc-500 text-sm md:text-base">{item.description}</p>
        </div>
      ))}
    </div>

  </section>
</div>
{/* <LogisticsShowcase/> */}

 {/* Send a Message Section */}
 <div className=' flex flex-col xl:flex-row justify-center bg-black items-center'>

 <div className="w-full lg:w-1/2 flex justify-center items-center  bg-black xl:p-20">
          <div className="bg-white bg-opacity-10 backdrop-blur-md p-6 md:p-8 rounded-lg shadow-lg max-w-xl w-full">
            <h2 className="text-center text-2xl md:text-6xl font-thin mb-4 md:mb-6 text-white">Get a Quote</h2>
            <form ref={formRef} className="space-y-8 md:space-y-12" onSubmit={handleSubmit}>
              <div>
                <input
                  type="text"
                  id="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-white bg-transparent text-white placeholder-white rounded"
                />
                {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
              </div>
              <div>
                <input
                  type="text"
                  id="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-white bg-transparent text-white placeholder-white rounded"
                />
                {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
              </div>
              <div>
                <input
                  type="email"
                  id="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-white bg-transparent text-white placeholder-white rounded"
                />
                {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
              </div>
              <div>
                <textarea
                  id="description"
                  placeholder="Message"
                  value={formData.description}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-white bg-transparent text-white placeholder-white rounded"
                  rows="4"
                ></textarea>
                {errors.description && <p className="text-red-500 text-sm mt-1">{errors.description}</p>}
              </div>
              <button
                type="submit"
                className="w-full py-2 mt-4 border border-zinc-500 rounded-3xl text-white font-semibold hover:bg-zinc-800 transition"
              >
                Submit
              </button>
            </form>
          </div>
        </div>

        <div className="md:w-1/2 mx-auto text-center space-y-4 md:text-lg pb-12 px-4">
  <p className="text-2xl xl:text-4xl 2xl:text-5xl font-thin text-center md:leading-10 xl:leading-[45px] 2xl:leading-[80px] max-w-3xl mx-auto text-white">
    Get a quotation now! Book a call to discover how our platform delivers comprehensive end-to-end solutions tailored to your needs.
  </p>
  
  {/* Centering Buttons Horizontally */}
  <div className="flex justify-center items-center gap-6 pt-4">
    <a href="https://wa.me/+447862494152" target="_blank" rel="noopener noreferrer">
      <img className="md:h-12 md:w-60 lg:h-16 xl:h-20 w-40" src="images/wbtn.png" alt="WhatsApp Button" />
    </a>
    <Link to='/contactus'>
    <button className="bg-gray-600 text-white h-10 md:h-10 md:w-56 xl:h-14 w-40 lg:px-6 py-2  hover:bg-slate-600 transition-colors duration-300">
      Web Form
    </button></Link>



  </div>
</div>
        </div>
    </div>
    </div>
  );
}

export default Home;


// import React, { useRef, useEffect } from 'react';
// import LocationsMarquee from './LocationsMarquee';
// import TransportCards from './TransportCards';

// function Home() {
//   const videoRef = useRef(null);

//   useEffect(() => {
//     if (videoRef.current) {
//       videoRef.current.playbackRate = 1; 
//     }
//   }, []);

//   return (
//     <div>

//       <div className=''>


//       <div>
//         <video 
//           ref={videoRef} 
//           autoPlay 
//           loop 
//           muted 
//           playsInline
//         >
//           <source src='images/landingvideo.mp4' type='video/mp4' />
//           Your browser does not support the video .
//         </video>
//       </div>

//       <div className="absolute top-60 left-20 max-w-xl ">
//   <p className="text-white md:text-3xl font-bold">
//   Your Trusted Logistics Partner in the UK.
//   </p>

//   <div className="bg-white/10 backdrop-blur-md  text-justify text-lg  border border-whitetext-xl text-white p-8 rounded-lg shadow-lg mt-4">
//     <p>
//       Logistics involves the planning, management, and movement of goods, services, and information from origin to destination. 
//       It includes coordinating transportation, warehousing, inventory, and distribution to ensure efficient and timely delivery.
//       Logistics plays a crucial role in supply chains, helping businesses streamline operations, reduce costs, and meet customer demands.
//     </p>

//     <div className='flex justify-center'>
//     <button className='bg-slate-800 text-white px-6 py-2 rounded-md mt-6'>Contact us</button>
//     </div>
//   </div>
// </div>




//       </div>




// <LocationsMarquee/>

// {/* <TransportCards/> */}

// <div className="flex flex-col md:flex-row items-center p-4 md:p-8  justify-center space-y-6 md:space-y-0 md:gap-60 mt-32">
//   {/* Image Section */}
//   <div className="md:w-1/3 flex justify-center">
//     <img 
//       src="images/img2.png" 
//       alt="Freight Platform" 
//       className="w-full h-auto max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
//     />
//   </div>

//   {/* Text Section */}
//   <div className="md:w-1/3 text-center md:text-left space-y-4 md:text-lg">
//     <p className="text-2xl md:text-4xl font-bold text-gray-800">
//     Experience a comprehensive, all-in one platform for digital freight solutions.
//     </p>
//     <p className="text-2xl  text-justify max-w-xl leading-relaxed text-gray-600">
//     Leave behind the confusion of calls, faxes, and endless emails. Enter a unified platform where suppliers, 
//     shippers, customs, ports, and more come together for smooth and contextual collaboration
//     </p>
//     <div className='flex justify-center pt-4'>
//     <button className="bg-slate-800 text-white px-6 py-2 rounded-xl hover:bg-slate-600 transition-colors duration-300">
//       Schedule a Demo
//     </button>
//     </div>
   
//   </div>
// </div>



// <div className="flex flex-col md:flex-row items-center p-4 md:p-8  justify-center space-y-6 md:space-y-0 md:gap-60">
//    {/* Text Section */}
//    <div className="md:w-1/3 text-center md:text-left space-y-4 md:text-lg">
//     <p className="text-2xl md:text-4xl font-bold text-gray-800">
//     Adaptable logistics solutions, where technology meets expertise, 
//     ensuring you fulfill your commitments to your customers.
//     </p>
//     <p className="text-2xl  text-justify max-w-xl leading-relaxed text-gray-600">
//     Break free from the clutter of calls, faxes, and endless emails. Enter an interconnected realm where suppliers, 
//     shippers, customs, ports, and more unite on one platform for effortless and context-driven collaboration.
//     </p>
    
//   </div>
//   {/* Image Section */}
//   <div className="md:w-1/3 flex justify-center">
//     <img 
//       src="images/img3.png" 
//       alt="Freight Platform" 
//       className="w-full h-auto max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
//     />
//   </div>

 
// </div>


// <div className="flex flex-col md:flex-row items-center p-4 md:p-8  justify-center space-y-6 md:space-y-0 md:gap-60">
//   {/* Image Section */}
//   <div className="md:w-1/3 flex justify-center">
//     <img 
//       src="images/img4.png" 
//       alt="Freight Platform" 
//       className="w-full h-auto max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
//     />
//   </div>

//   {/* Text Section */}
//   <div className="md:w-1/3 text-center md:text-left space-y-4 md:text-lg">
//     <p className="text-2xl md:text-4xl font-bold text-gray-800">
//     Uncover your comprehensive digital freight solution platform.
//     </p>
//     <p className="text-2xl  max-w-xl leading-relaxed text-gray-600">
//     Our solutions are customized to suit your business and its distinct workflows, providing real-time order tracking from placement to delivery. Stay informed with the latest order statuses, monitor progress,
//      and receive timely notifications for important milestones, whether shipping by air, sea, or road
//     </p>
//     <div className='flex justify-center pt-4'>
//     <button className="bg-slate-800 text-white px-6 py-2 rounded-xl hover:bg-slate-600 transition-colors duration-300">
//       Schedule a Demo
//     </button>
//     </div>
//   </div>
// </div>


// <div className="flex flex-col md:flex-row items-center p-4 md:p-8  justify-center space-y-6 md:space-y-0 md:gap-60 mb-20">
//    {/* Text Section */}
//    <div className="md:w-1/3 text-center md:text-left space-y-4 md:text-lg">
//     <p className="text-2xl md:text-4xl font-bold text-gray-800">
//     Explore your all-in-one solution for digital freight management.
//     </p>
//     <p className="text-2xl  max-w-xl leading-relaxed text-gray-600">
//     Break free from the turmoil of calls, faxes, and endless emails. Enter a connected ecosystem where suppliers, shippers, 
//     customs, ports, and more unite on a single platform for effortless and contextual collaboration.
//     </p>
    
//   </div>
//   {/* Image Section */}
//   <div className="md:w-1/3 flex justify-center">
//     <img 
//       src="images/img5.png" 
//       alt="Freight Platform" 
//       className="w-full h-auto max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
//     />
//   </div>

 
// </div>

// {/* News letter */}

// <div className='bg-slate-800 justify-center text-center p-20 mx-96 rounded-xl'>
// <div>
// <p className="text-white text-center text-3xl font-bold">
//    Subscribe to Our News Letter
//   </p>
// </div>
//   <div className='flex gap-1 justify-center mt-8'>
// <input className='h-14 w-[500px] text-xl  rounded-md text-center' type='text' placeholder='Enter Your Email address'></input>
// <button className=' bg-orange-500 text-white font-semibold p-4 w-40 rounded-md'> Subscribe</button>
//   </div>
// </div>


// <div className="flex flex-col md:flex-row items-center p-4 md:p-8  justify-center space-y-6 md:space-y-0 md:gap-60 mt-20">
//   {/* Image Section */}
//   <div className="md:w-1/3 flex justify-center">
//     <img 
//       src="images/img1.png" 
//       alt="Freight Platform" 
//       className="w-full h-auto max-w-xs md:max-w-full rounded-lg transition-transform duration-300 ease-in-out transform hover:scale-105"
//     />
//   </div>

//   {/* Text Section */}
//   <div className="md:w-1/3 text-center md:text-justify space-y-4 md:text-lg">
//     <p className="text-2xl md:text-5xl font-bold text-gray-800">
//     Book a call to discover how our platform provides comprehensive end-to-end solutions.
//     </p>
   
   
//     <div className='flex justify-center gap-6 pt-4'>
  
  
// <a
//   href="https://wa.me/9573039917" 
//   target="_blank"
//   rel="noopener noreferrer"
//   className="bg-green-500 text-white px-6 py-2 rounded-xl hover:bg-green-600 transition-colors duration-300"
// >
//   Whats App
// </a>

//     <button className="bg-slate-800 text-white px-6 py-2 rounded-xl hover:bg-slate-600 transition-colors duration-300">
//       Contact us Form
//     </button>

//     </div>
//   </div>
// </div>

//     </div>
//   );
// }

// export default Home;
